import axios from '../utils/axios';

/**
 * Get job history
 * @param {string} adminId - Admin ID
 * @param {string} jobName - Job name
 * @param {Object} params - Query parameters (year, month, day)
 * @returns {Promise} API response
 */
export default function fetchCronJobHistory(adminId, jobName, params = {}) {
    return axios.get(`/admin/${adminId}/cron/jobs/${jobName}/history`, { params });
}
